import React, { useMemo, useState } from 'react';
import Button from '../../components/UI/Button';

export default function CandidateFilters({ filters, onFilterChange, onClear }) {
	const [local, setLocal] = useState(filters);
	function setField(key, value) {
		setLocal((f) => ({ ...f, [key]: value }));
	}
	function toggleArray(key, value) {
		setLocal((f) => {
			const set = new Set(f[key] || []);
			if (set.has(value)) set.delete(value);
			else set.add(value);
			return { ...f, [key]: Array.from(set) };
		});
	}
	const activeCount = useMemo(() => {
		let c = 0;
		if (local.search) c++;
		if (local.experienceLevel?.length) c++;
		if (local.skills?.length) c++;
		if (local.location) c++;
		if (local.education) c++;
		if (local.status) c++;
		if (local.scoreMin || local.scoreMax) c++;
		if (local.startDate || local.endDate) c++;
		return c;
	}, [local]);
	return (
		<div className="border rounded p-4 bg-white">
			<div className="flex items-center justify-between">
				<h3 className="font-semibold">Filters</h3>
				{activeCount > 0 && <span className="text-xs bg-gray-100 px-2 py-0.5 rounded">{activeCount}</span>}
			</div>
			<div className="mt-3 space-y-3">
				<input className="w-full border rounded px-3 py-2 text-sm" placeholder="Search by name, skills, keywords" value={local.search || ''} onChange={(e) => setField('search', e.target.value)} />
				<section>
					<p className="text-sm font-medium">Experience Level</p>
					<div className="grid grid-cols-2 gap-2 text-sm mt-1">
						{['entry', 'mid', 'senior', 'lead'].map((lvl) => (
							<label key={lvl} className="flex items-center gap-2">
								<input type="checkbox" checked={local.experienceLevel?.includes(lvl)} onChange={() => toggleArray('experienceLevel', lvl)} /> {lvl}
							</label>
						))}
					</div>
				</section>
				<section>
					<p className="text-sm font-medium">Skills</p>
					<input className="w-full border rounded px-3 py-2 text-sm" placeholder="Comma separated skills" value={(local.skills || []).join(', ')} onChange={(e) => setField('skills', e.target.value.split(',').map((s) => s.trim()).filter(Boolean))} />
				</section>
				<section className="grid grid-cols-2 gap-2">
					<div>
						<p className="text-sm font-medium">Location</p>
						<input className="w-full border rounded px-3 py-2 text-sm" value={local.location || ''} onChange={(e) => setField('location', e.target.value)} />
					</div>
					<div>
						<p className="text-sm font-medium">Education</p>
						<select className="w-full border rounded px-3 py-2 text-sm" value={local.education || ''} onChange={(e) => setField('education', e.target.value)}>
							<option value="">Any</option>
							<option value="bachelor">Bachelor's</option>
							<option value="master">Master's</option>
							<option value="phd">PhD</option>
						</select>
					</div>
				</section>
				<section className="grid grid-cols-2 gap-2">
					<div>
						<p className="text-sm font-medium">Score Min</p>
						<input className="w-full border rounded px-3 py-2 text-sm" type="number" value={local.scoreMin || 0} onChange={(e) => setField('scoreMin', Number(e.target.value) || 0)} />
					</div>
					<div>
						<p className="text-sm font-medium">Score Max</p>
						<input className="w-full border rounded px-3 py-2 text-sm" type="number" value={local.scoreMax || 100} onChange={(e) => setField('scoreMax', Number(e.target.value) || 0)} />
					</div>
				</section>
				<section className="grid grid-cols-2 gap-2">
					<div>
						<p className="text-sm font-medium">Start Date</p>
						<input className="w-full border rounded px-3 py-2 text-sm" type="date" value={local.startDate || ''} onChange={(e) => setField('startDate', e.target.value)} />
					</div>
					<div>
						<p className="text-sm font-medium">End Date</p>
						<input className="w-full border rounded px-3 py-2 text-sm" type="date" value={local.endDate || ''} onChange={(e) => setField('endDate', e.target.value)} />
					</div>
				</section>
			</div>
			<div className="mt-3 flex items-center justify-between">
				<Button variant="ghost" onClick={onClear}>
					Clear Filters
				</Button>
				<Button onClick={() => onFilterChange?.(local)}>Apply Filters</Button>
			</div>
		</div>
	);
}


